import { useState } from 'react';
import { toast } from 'react-toastify';
import { Edit, Save, X, Settings, KeyRound } from 'lucide-react';
import { Button } from '@components/ui';
import { ProfileCard, ProfileForm, ActivityLog } from './components';

export default function Profile() {
    const [isEditing, setIsEditing] = useState(false);
    const [profile, setProfile] = useState({
        name: 'Mücahit Çetin',
        email: 'mucahit@insaet.com',
        phone: '0506 101 05 01',
        role: 'Sistem Yöneticisi',
        company: 'İNSAET',
        address: 'Çukurova, Adana',
        bio: 'Proje yönetimi ve finansal takip uzmanı.',
    });


    const [formData, setFormData] = useState(profile);

    const handleFieldChange = (field, value) => {
        setFormData(prev => ({ ...prev, [field]: value }));
    };

    const handleSave = () => {
        setProfile(formData);
        setIsEditing(false);
        toast.success('Profil bilgileriniz başarıyla güncellendi');
    };

    const handleCancel = () => {
        setFormData(profile);
        setIsEditing(false);
    };

    return (
        <div className="p-4 md:p-6 space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-text-primary">Profil</h1>
                    <p className="text-text-tertiary mt-1">Hesap bilgilerinizi yönetin</p>
                </div>
                <div className="flex gap-2">
                    {!isEditing ? (
                        <>
                            <Button
                                variant="soft-primary"
                                icon={<Settings size={18} />}
                                onClick={() => window.location.href = '/ayarlar'}
                            >
                                Ayarlar
                            </Button>
                            <Button
                                variant="primary"
                                icon={<Edit size={18} />}
                                onClick={() => setIsEditing(true)}
                            >
                                Düzenle
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button variant="ghost" icon={<X size={18} />} onClick={handleCancel}>
                                İptal
                            </Button>
                            <Button variant="success" icon={<Save size={18} />} onClick={handleSave}>
                                Kaydet
                            </Button>
                        </>
                    )}
                </div>
            </div>

            {/* Main Content */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                {/* Left Column - Profile Card */}
                <div className="lg:col-span-4 space-y-6">
                    <ProfileCard profile={profile} isEditing={isEditing} />

                    {/* Quick Actions */}
                    <div className="bg-bg-secondary rounded-2xl border border-border-light p-5">
                        <h3 className="font-semibold text-text-primary mb-4">Hızlı İşlemler</h3>
                        <div className="space-y-2">
                            <button className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-bg-tertiary/50 hover:bg-bg-tertiary text-text-secondary hover:text-text-primary transition-all text-left">
                                <KeyRound size={18} />
                                <span className="text-sm font-medium">Şifre Değiştir</span>
                            </button>
                            <button className="w-full flex items-center gap-3 px-4 py-3 rounded-xl bg-bg-tertiary/50 hover:bg-bg-tertiary text-text-secondary hover:text-text-primary transition-all text-left">
                                <Settings size={18} />
                                <span className="text-sm font-medium">Bildirim Ayarları</span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Right Column - Form & Activity */}
                <div className="lg:col-span-8 space-y-6">
                    <ProfileForm
                        formData={formData}
                        profile={profile}
                        isEditing={isEditing}
                        onFieldChange={handleFieldChange}
                    />
                    <ActivityLog />
                </div>
            </div>
        </div>
    );
}
